import React from 'react'

export const CoberturaHomeComponent = () => {
  return (
    <section className='cobertura container'>
        <div className='cobertura__banner'>
          <div className='banner'></div>
        </div>
        <div className='cobertura__container'>
            <h1 className='cobertura__title'>LA COBERTURA PERFECTA PARA TI</h1>
            <h2 className='cobertura__subtitle'>Más que un corredor, somos un aliado efectivo, nos dedicamos a conocer a fondo tus objetivos y así ofrecerte soluciones y productos de seguros, satisfaciendo tus necesidades reales.</h2>
        </div>
    </section>
  )
}
